import apiClient from '../axios';
import _ from "lodash";

export async function dashboard() {
  return apiClient
    .get(`/statistics/dashboard`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function basicMembersBySport(countryId) {
  return apiClient
    .get(`/country/${countryId}/statistics/basic/members/sport`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function basicRegistrationsByPlace(countryId) {
  return apiClient
    .get(`/country/${countryId}/statistics/basic/registrations/place`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function basicMembersWithoutConsentByPlace(countryId) {
  return apiClient
    .get(`/country/${countryId}/statistics/basic/members-without-consent/place`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function registrationSportsByPlace(countryId, placeId) {
  return apiClient
    .get(`/country/${countryId}/statistics/basic/registrations/place/${placeId}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function registrationsByPlace(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
    .post(`/country/${countryId}/statistics/registrations/place?${sortingQuery}`, filter)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function registrationsBySport(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
    .post(`/country/${countryId}/statistics/registrations/sport?${sortingQuery}`, filter)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function exportRegistrationsByPlace(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/statistics/registrations/place/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportRegistrationsBySport(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/statistics/registrations/sport/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function membersByPlace(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
    .post(`/country/${countryId}/statistics/members/place?${sortingQuery}`, filter)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function membersBySport(countryId, sorting, filter) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
    .post(`/country/${countryId}/statistics/members/sport?${sortingQuery}`, filter)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function exportMembersByPlace(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/statistics/members/place/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}

export async function exportMembersBySport(countryId, sorting, filter, format, name) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
      .post(`/country/${countryId}/statistics/members/sport/export/${format}?${sortingQuery}`, filter, {
        responseType: 'blob',
      })
      .then(response => {
        if (response) {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${format}`);
          document.body.appendChild(link);
          link.click();

          return response
        }
        return false
      })
      .catch(err => err && err);
}
